import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Auth/Login.vue'),
    meta: {
      title: `${t('login')} | Pour Now`,
    },
  },
  {
    path: '/invitation/accept',
    name: 'InvitationAccept',
    component: () => import('@/views/Auth/InvitationAccept.vue'),
    meta: {
      title: `${t('invitation')} | Pour Now`,
    },
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import('@/views/Auth/PasswordReset.vue'),
    meta: {
      title: `${t('reset_password')} | Pour Now`,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/Auth/ForgotPassword.vue'),
    meta: {
      title: `${t('forgot_password_no_question')} | Pour Now`,
    },
  },
  {
    path: '/signup-business',
    name: 'SignupBusiness',
    component: () => import('@/views/Auth/SignupBusiness.vue'),
    meta: {
      requiresAuth: true,
      title: `${t('complete_info')} | Pour Now`,
    },
  },
  {
    path: '/signup-subscription',
    name: 'SignupSubscription',
    component: () => import('@/views/Auth/SignupSubscription.vue'),
    meta: {
      requiresAuth: true,
      title: `${t('sign_up')} | Pour Now`,
    },
  },
  {
    path: '/two-factor-auth',
    name: 'TwoFactorAuth',
    component: () => import('@/views/Auth/TwoFactorAuth.vue'),
    meta: {
      title: `${t('two_factor_auth')} | Pour Now`,
    },
  },
  {
    path: '/select-business',
    name: 'SelectBusiness',
    component: () => import('@/views/Auth/SelectBusiness.vue'),
    meta: {
      requiresAuth: true,
      title: `${t('select_business')} | Pour Now`,
    },
  },
]
